export const environment = {
    env: 'STAGING',
    supportedLocales: ['en', 'nl'],
    defaultLocale: 'nl',
    fallbackLocale: 'en',
    mapBox: {
        token: 'pk.eyJ1IjoiYmFzZWZsb3ctZGV2IiwiYSI6ImNrZGhnaThscDJmNnoydG1oeGxyMDNobXYifQ.o3ycq_OmAoMlQwDye8eXGw',
        style: 'mapbox://styles/baseflow-dev/ckdhh123q16v51ip4ptcbs4tb',
    },
    auth: {
        baseUrl: 'https://auth.staging.onego.io',
        realm: 'onego-stg',
        clientId: 'onego-userportal',
    },
};
